/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { ApproveRequestDetail } from 'models/approves/ReferenceOpinion';
import { tb } from 'components/layouts/Table';
import { CommonUtil } from '../../utils/CommonUtil';
import { FileuploadBtn } from '../../components/buttons/CustomButton';
import FileUploadPopUp from '../common/components/FileUploadPopUp';

type propsType = {
  approveInfo: ApproveRequestDetail;
};

const ApproveDetailBasicInfo = ({ approveInfo }: propsType) => {
  const { t } = useTranslation();

  // 결재 첨부파일 추가
  const [isOpenFileUploadPopUp, setOpenFileUploadPopUp] = useState<boolean>(false);
  const [fileUploadModalCondition, setFileUploadModalCondition] = useState<any>();
  const handleFileUpload = async () => {
    setFileUploadModalCondition({
      atchFileGrId: approveInfo.aprFileGrId,
      atchFileTpCd: 'APPR_REQUEST',
      tableName: 'tb_elm_apr_req_m',
      bizName: 'appr',
    });
    setOpenFileUploadPopUp(true);
  };

  return (
    <>
      <TableContainer css={tb.customTable} sx={{ maxWidth: '100%' }}>
        <Table sx={{ tableLayout: 'fixed', minWidth: 700 }}>
          <TableBody>
            <TableRow>
              <TableCell className="bgGray">{t('com.label.요청 ID', '요청 ID')}</TableCell>
              <TableCell className="w500">{approveInfo.aprReqId}</TableCell>
              <TableCell className="bgGray">{t('com.label.진행상태', '진행상태')}</TableCell>
              <TableCell className="w500">{approveInfo.aprReqProgStatNm}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="bgGray">{t('com.label.작성자', '작성자')}</TableCell>
              <TableCell className="w500">{approveInfo.aprReqUserNm}</TableCell>
              <TableCell className="bgGray">{t('com.label.결재요청양식', '요청양식')}</TableCell>
              <TableCell className="w500">{approveInfo.aprTplNm}</TableCell>
              {/*
            // TODO [24.03.22] 전자결재 시 일반문서(0) 고정으로 사용 (따로 저장하지 않음)
            <TableCell>{t('com.label.문서종류', '문서종류')}</TableCell>
            <TableCell className="w500">{approveInfo.apprSecurityType}</TableCell>
            */}
            </TableRow>
            <TableRow>
              <TableCell className="bgGray">{t('com.label.작성일시', '작성일시')}</TableCell>
              <TableCell className="w500">{approveInfo.aprReqDtm ?? ''}</TableCell>
              <TableCell className="bgGray">{t('com.label.보존년한', '보존년한')}</TableCell>
              <TableCell className="w500">{approveInfo.aprPvnDdlnNm}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="bgGray">{t('com.label.제목', '제목')}</TableCell>
              <TableCell>{approveInfo.aprReqTitNm}</TableCell>
              <TableCell className="bgGray">{t('com.label.첨부', '첨부')}</TableCell>
              <TableCell>
                <FileuploadBtn onClick={handleFileUpload}>
                  <span>{Number(approveInfo?.fileCount || 0).toLocaleString()}</span>
                </FileuploadBtn>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="bgGray">{t('com.label.요청내용', '요청내용')}</TableCell>
              <TableCell
                className="editCont"
                colSpan={3}
                sx={{
                  width: 200,
                  whiteSpace: 'nowrap',
                  overflow: 'auto',
                  textOverflow: 'ellipsis',
                }}
              >
                <div
                  style={{
                    height: 'fit-content',
                    maxHeight: 300,
                    whiteSpace: 'pre-wrap',
                    overflowWrap: 'anywhere',
                    wordBreak: 'break-word',
                  }}
                  dangerouslySetInnerHTML={{
                    __html: CommonUtil.safeHtmlContents(approveInfo.trnmBdyCtn, false),
                  }}
                ></div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {/* 첨부파일 팝업 */}
      {isOpenFileUploadPopUp && (
        <FileUploadPopUp
          open={isOpenFileUploadPopUp}
          close={() => setOpenFileUploadPopUp(false)}
          downloadOnly={true}
          initParam={{
            atchFileGrId: fileUploadModalCondition?.atchFileGrId,
            atchFileTpCd: fileUploadModalCondition?.atchFileTpCd,
            optValCtn1: fileUploadModalCondition?.tableName,
            bizName: fileUploadModalCondition?.bizName,
          }}
          onCallback={(atchFileGrId, fileCount) => {
            setOpenFileUploadPopUp(false);
          }}
        />
      )}
    </>
  );
};

export default ApproveDetailBasicInfo;
